import { API_BASE_URL } from './api';
import { authService } from './authService';

const authHeaders = (): Record<string, string> => ({ ...authService.getAuthHeaders() } as Record<string, string>);
const authJsonHeaders = (): Record<string, string> => ({ 'Content-Type': 'application/json', ...authHeaders() });

export interface GroupMessage {
  groupId: string;
  messageId: string;
  senderUserId: string;
  senderDisplayName: string;
  senderProfilePhotoUrl?: string | null;
  text: string;
  createdAt: string;
}

const errorFrom = async (res: Response, fallback: string): Promise<string> => {
  try {
    const body = await res.text();
    return body || fallback;
  } catch {
    return fallback;
  }
};

// Same polling-based approach as messageService — this app has no realtime transport.
export const groupMessageService = {
  getMessages: async (groupId: string): Promise<GroupMessage[]> => {
    const res = await fetch(`${API_BASE_URL}/groups/${encodeURIComponent(groupId)}/messages`, { headers: authHeaders() });
    if (!res.ok) throw new Error(await errorFrom(res, 'Failed to load group messages'));
    return res.json();
  },

  getUnread: async (groupId: string): Promise<boolean> => {
    const res = await fetch(`${API_BASE_URL}/groups/${encodeURIComponent(groupId)}/messages/unread`, { headers: authHeaders() });
    if (!res.ok) throw new Error(await errorFrom(res, 'Failed to load unread status'));
    const body = await res.json();
    return !!body.hasUnread;
  },

  sendMessage: async (groupId: string, text: string): Promise<GroupMessage> => {
    const res = await fetch(`${API_BASE_URL}/groups/${encodeURIComponent(groupId)}/messages`, {
      method: 'POST',
      headers: authJsonHeaders(),
      body: JSON.stringify({ text }),
    });
    if (!res.ok) throw new Error(await errorFrom(res, 'Failed to send message'));
    return res.json();
  },
};
